import { Button } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';

import { StepFormContextProvider } from '../../provider';
import { OnboardingStep } from '../OnboardingStep';
import { CompanyAccess } from '../forms';

type Props = unknown;

/**
 * OnboardingExistingCompanyAccess.
 * Step that renders the form for the other roles of the company.
 * It is splitted on purpose, to keep the form agnostic of useLegalIdentityForm().
 *
 * @returns {JSX.Element}
 */
export function OnboardingExistingCompanyAccess(): JSX.Element {
  const i18nGeneral = useTranslations('General');
  const i18nOtherRoleStep = useTranslations('OtherRoleStep');

  const navigate = useNavigate();

  const { companyId = '' } = useParams();

  const handleStepSubmit = (): void => {
    navigate(routes.onboardings.company.summary.fmt(companyId));
  };

  const handleStepCancel = (): void => {
    navigate(routes.onboardings.company.owners.fmt(companyId));
  };

  return (
    <StepFormContextProvider>
      <OnboardingStep
        subTitle={i18nOtherRoleStep('OnboardingExistingSubTitle')}
        title={i18nOtherRoleStep('Title')}
      >
        <CompanyAccess onCancel={handleStepCancel} onSubmit={handleStepSubmit} />
        <Button key="cancel" variant="secondary" w="full">
          {i18nGeneral('Back')}
        </Button>
        <Button key="submit" data-cy="next" w="full">
          {i18nGeneral('Next')}
        </Button>
      </OnboardingStep>
    </StepFormContextProvider>
  );
}

export type OnboardingExistingCompanyAccessProps = Props;
